import { push } from 'react-router-redux';
import { fetchUser } from './fetch-user';

const defaultUrlBuilder = (user, search) => `/profiles/${user.slug}${search}`;

export const fetchUserAndRedirect = (userId, search, urlBuilder = defaultUrlBuilder) => {
  return dispatch => {
    return dispatch(fetchUser(userId)).then(user => {
      if (userId !== user._id && userId !== user.slug) {
        dispatch(push({ pathname: urlBuilder(user, search), state: 301 }));
      }
      return user;
    });
  };
};



// WEBPACK FOOTER //
// ./app/actions/fetch-user-and-redirect.js